import styled from '@emotion/styled';

// El card vive en Components/CourseCardV2; aquí solo queda el layout de la lista.
export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 14px;
  margin-top: 12px;
`;
